module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"post_transplant_follow_up":"Post-Transplant Follow-Up"},"fr":{"post_transplant_follow_up":"Suivi post-transplantation"}}')
  delete Component.options._Ctor
}
